// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_country_content .MuiListItem-container{
    list-style-type: none;
    width: 100%;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background-color: var(--new-background-color);
    margin-right: 10px;
}

.search_country_autocomplete__img-selected-option{
    position: relative;
    background-color: var(--white-color);
    border-radius: var( --space-half ) 0px 0px var( --space-half );
    border: solid 1.5px var(--new-gray-background-color);
    height: var(--space-x3);
    border-right: none;
}

.search_country_autocomplete__img-selected-option:hover{
    cursor: pointer;
}

.tournament-new-match__input-member .search_country_content .baloa-username{
    font-style: initial;
    color:var(--primary-very-dark-color);
}

.league-search-member-team-container .scroll-parent.league-search-profile__list{
    z-index: 999;
}

.search_country_content .league-search-member-team-container .league-search-member-team-form__box .input-search__input{
    background-color: var(--white-color);
    padding: var(--space-half);
}

.search_country_content.match_assigner .baloa-username{
    font-style: initial;
    color: var(--primary-very-dark-color);
}

.search-field-autocomplete__selected-country{
    width: 108px;
    height: 44px;
    display: grid;
    justify-items: center;
    align-items: center;
    padding: 3.8px;
}

.search-field-autocomplete_flag_country{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    gap: var(--space-half);
}

.search-field-autocomplete_flag_country:hover{
    cursor: pointer;
}

.search-field-autocomplete_flag_country .baloa-normal{
    color: var(--primary-dark-color);
}

.dropdown-countries {
    display: none;
    position: absolute;
    width: 380px;
    height: 410px;
    overflow: auto;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.082);
    background-color: var(--white-color);
    padding: var(--space);
    border-radius: var(--space-half);
    top: 50px;
    z-index: 1;
}

.dropdown-countries._active{
    display: block;
}

.search_country_content.country_code .MuiAutocomplete-popperDisablePortal {
    position: absolute;
    top: 116px;
    left: 30px;
}

.search_country_content.country_code .MuiAutocomplete-popperDisablePortal .MuiPaper-elevation1{
    box-shadow: none;
}

.search_country_content.country_code .MuiPaper-root.MuiAutocomplete-paper .MuiAutocomplete-listbox{
    max-height: 320px;
}

.search_country_input_autocomple__list__icon{
    margin-right: calc( var(--space-half) /2);
}

.search_country_input_autocomple__list__icon__img{
    width: 18px;
    height: 18px;
    border-radius: 50%;
}

.search_country_input_autocomple__list.MuiListItem-gutters {
    padding-left: 8px;
    padding-right: 8px;
}

.MuiListItemText-root.search_country_input_autocomple__listitem {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

.search_country_input_autocomple__listitem .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );
    line-height: calc(var(--space) + 4);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color) !important;
}

.search_country_input_autocomple__listitem .MuiTypography-colorTextSecondary {    
    color: var(--basic-gray-color);
    font-size: var(--space-half-quarter);
    line-height: 16px;
}

.search_country_input_autocomple__list__icon .icon-ball{
    color: var(--white-color);
    font-size: 16px;
    padding: 3px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
}

.search-field-autocomplete_flag_country .icon-ball {
    color: var(--white-color);
    font-size: 16px;
    padding: 3px;
    border-radius: 50%;
}

.search-field__message.baloa-username {
    color: var(--error-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .search-field-autocomplete__selected-country{
        height: 26px;
        padding: 0px;
    }

    .search_country_content.country_code .MuiAutocomplete-popperDisablePortal {
        position: absolute;
        top: 97px;
        left: 17px;
    }

    .search-field-autocomplete_flag_country .search_country_input_autocomple__list__icon__img{
        width: 24px;
        height: 24px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-member-search-icon/LeagueCountrySearchIconComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,kDAAkD;IAClD,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,8DAA8D;IAC9D,oDAAoD;IACpD,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kDAAkD;IAClD,oCAAoC;IACpC,qBAAqB;IACrB,gCAAgC;IAChC,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ","sourcesContent":[".search_country_content .MuiListItem-container{\n    list-style-type: none;\n    width: 100%;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background-color: var(--new-background-color);\n    margin-right: 10px;\n}\n\n.search_country_autocomplete__img-selected-option{\n    position: relative;\n    background-color: var(--white-color);\n    border-radius: var( --space-half ) 0px 0px var( --space-half );\n    border: solid 1.5px var(--new-gray-background-color);\n    height: var(--space-x3);\n    border-right: none;\n}\n\n.search_country_autocomplete__img-selected-option:hover{\n    cursor: pointer;\n}\n\n.tournament-new-match__input-member .search_country_content .baloa-username{\n    font-style: initial;\n    color:var(--primary-very-dark-color);\n}\n\n.league-search-member-team-container .scroll-parent.league-search-profile__list{\n    z-index: 999;\n}\n\n.search_country_content .league-search-member-team-container .league-search-member-team-form__box .input-search__input{\n    background-color: var(--white-color);\n    padding: var(--space-half);\n}\n\n.search_country_content.match_assigner .baloa-username{\n    font-style: initial;\n    color: var(--primary-very-dark-color);\n}\n\n.search-field-autocomplete__selected-country{\n    width: 108px;\n    height: 44px;\n    display: grid;\n    justify-items: center;\n    align-items: center;\n    padding: 3.8px;\n}\n\n.search-field-autocomplete_flag_country{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: row;\n    gap: var(--space-half);\n}\n\n.search-field-autocomplete_flag_country:hover{\n    cursor: pointer;\n}\n\n.search-field-autocomplete_flag_country .baloa-normal{\n    color: var(--primary-dark-color);\n}\n\n.dropdown-countries {\n    display: none;\n    position: absolute;\n    width: 380px;\n    height: 410px;\n    overflow: auto;\n    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.082);\n    background-color: var(--white-color);\n    padding: var(--space);\n    border-radius: var(--space-half);\n    top: 50px;\n    z-index: 1;\n}\n\n.dropdown-countries._active{\n    display: block;\n}\n\n.search_country_content.country_code .MuiAutocomplete-popperDisablePortal {\n    position: absolute;\n    top: 116px;\n    left: 30px;\n}\n\n.search_country_content.country_code .MuiAutocomplete-popperDisablePortal .MuiPaper-elevation1{\n    box-shadow: none;\n}\n\n.search_country_content.country_code .MuiPaper-root.MuiAutocomplete-paper .MuiAutocomplete-listbox{\n    max-height: 320px;\n}\n\n.search_country_input_autocomple__list__icon{\n    margin-right: calc( var(--space-half) /2);\n}\n\n.search_country_input_autocomple__list__icon__img{\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n}\n\n.search_country_input_autocomple__list.MuiListItem-gutters {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n.MuiListItemText-root.search_country_input_autocomple__listitem {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n}\n\n.search_country_input_autocomple__listitem .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );\n    line-height: calc(var(--space) + 4);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color) !important;\n}\n\n.search_country_input_autocomple__listitem .MuiTypography-colorTextSecondary {    \n    color: var(--basic-gray-color);\n    font-size: var(--space-half-quarter);\n    line-height: 16px;\n}\n\n.search_country_input_autocomple__list__icon .icon-ball{\n    color: var(--white-color);\n    font-size: 16px;\n    padding: 3px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 11px;\n}\n\n.search-field-autocomplete_flag_country .icon-ball {\n    color: var(--white-color);\n    font-size: 16px;\n    padding: 3px;\n    border-radius: 50%;\n}\n\n.search-field__message.baloa-username {\n    color: var(--error-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .search-field-autocomplete__selected-country{\n        height: 26px;\n        padding: 0px;\n    }\n\n    .search_country_content.country_code .MuiAutocomplete-popperDisablePortal {\n        position: absolute;\n        top: 97px;\n        left: 17px;\n    }\n\n    .search-field-autocomplete_flag_country .search_country_input_autocomple__list__icon__img{\n        width: 24px;\n        height: 24px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
